<div
  class="relative flex w-full items-center justify-center"
  [ngClass]="{ 'max-w-40': !fullWidth() }">
  <canvas #ProgressBar class="h-7 w-full rounded-md"></canvas>
</div>
